/**
 * ReportPageHeader — R5 (2026-05-17) — shared back-link + title + actions
 * for individual report pages. Includes scroll-to-top on mount (smoke
 * test surfaced: opening a report from /reports left scroll where the
 * cards were, hiding the report header).
 */

import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeftIcon } from "@heroicons/react/24/outline";

interface Props {
  title: string;
  description?: React.ReactNode;
  badges?: React.ReactNode;
  actions?: React.ReactNode;
}

const ReportPageHeader: React.FC<Props> = ({
  title,
  description,
  badges,
  actions,
}) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="flex items-center justify-between">
      <div>
        <Link
          to="/reports"
          className="inline-flex items-center gap-1 text-sm text-gray-600 hover:text-gray-900"
        >
          <ArrowLeftIcon className="h-4 w-4" />
          Back to Reports
        </Link>
        <div className="mt-2 flex items-center gap-2">
          <h1 className="text-2xl font-semibold text-gray-900">{title}</h1>
          {badges}
        </div>
        {description && (
          <p className="mt-1 text-sm text-gray-600">{description}</p>
        )}
      </div>
      {actions && <div>{actions}</div>}
    </div>
  );
};

export default ReportPageHeader;
